/**
 * Facts about the site and the company that appear in more than one place.
 *
 * Anything a lawyer, a registrar or an app store would care about lives here
 * rather than being typed into each page, so there is exactly one line to
 * change when the company address or the support address changes.
 */

/*
 * The address that actually serves the site, and therefore what canonical
 * tags, hreflang and Open Graph URLs must point at.
 *
 * www, not the bare domain, because twocoins.app redirects to it — the same
 * convention as google.com and buildpassing.com. A canonical URL that
 * redirects wastes a hop and muddies the signal.
 *
 * PRODUCT.domain below stays bare: that one is read by humans, not machines.
 */
export { SITE_ORIGIN } from '../../shared/seo';

export const PRODUCT = {
  /*
   * "TwoCoins, always one word, capital T and C. Never 2Coins, Two Coins or
   * TWOCOINS." You may say "two coins" when explaining the idea, but the name
   * is never translated — it is TwoCoins in Spanish too.
   */
  name: 'TwoCoins',
  domain: 'twocoins.app',
  /* No country in the handle. Mexico is the home market, not a branch. */
  instagram: 'twocoins.app',
  instagramUrl: 'https://instagram.com/twocoins.app',
} as const;

/*
 * The company's facts live in src/shared/company.ts, because the server needs
 * them too: every email carries the postal address once there is one.
 */
export { COMPANY, hasPhone, hasPostalAddress } from '../../shared/company';

/*
 * The date the current legal texts took effect, and the age they set. Shared
 * with the server, which records the version a sign-up accepted.
 */
export { LEGAL_LAST_UPDATED, MIN_AGE } from '../../shared/legal';
